'use strict';

/**
 * Logger
 */
module.exports = {
    ignore: function ignore() {
        if (window.Owl && window.Owl.debugLog) {
            window.console.log('【OWL日志:】');
            window.console.log && window.console.log.apply(window.console, arguments);
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./~/@dp/owl/lib/util/logger.js
// module id = 30
// module chunks = 0